import clsx from 'clsx';
import React from 'react';
import Card from './Card';
import './style.scss';

const InfographicNumberCards = ({ fields = {}, params }) => {
  const { items } = fields;

  const shouldRenderItems = Array.isArray(items) && items.length > 0;

  return (
    <div className={clsx('infographic-number-card content', 'add-margins', params?.Styles)}>
      {shouldRenderItems && (
        <div className="row infographic-items">
          {items.map((item, index) => {
            return <Card key={index} data={item?.fields} />;
          })}
        </div>
      )}
    </div>
  );
};

export default InfographicNumberCards;
